import { currentLocale, intlLocale } from '../i18n';

const MONTHS = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
const DAYS = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];

/**
 * "1994-03-25" → "vr 25 maart 1994", "1994-03" → "maart 1994", "1994" → "1994".
 * In het Frans en Engels via Intl: "ven. 25 mars 1994", "Fri 25 March 1994".
 */
export function formatDate(value) {
  const [y, mo, d] = String(value).split('-').map(Number);
  if (!mo) return String(y);
  const date = new Date(Date.UTC(y, mo - 1, d || 1));

  if (currentLocale() !== 'nl' && typeof Intl !== 'undefined') {
    const options = d ? { weekday: 'short', day: 'numeric', month: 'long', year: 'numeric' } : { month: 'long', year: 'numeric' };
    return new Intl.DateTimeFormat(intlLocale(), Object.assign({ timeZone: 'UTC' }, options)).format(date).replace(/,/g, '');
  }

  if (!d) return `${MONTHS[mo - 1]} ${y}`;
  return `${DAYS[date.getUTCDay()]} ${d} ${MONTHS[mo - 1]} ${y}`;
}

/** 75 → "1:15" */
export function formatDuration(seconds) {
  const s = Math.round(seconds || 0);
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}
